import { queryOptions, useQuery } from '@tanstack/react-query'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

interface FindAuditLogsArgs {
  transaction_id: string
}

export const findAuditLogsQueryOptions = (args: FindAuditLogsArgs) =>
  queryOptions({
    queryKey: ['audit-logs', args],
    queryFn: () =>
      apiClient.logs.audit
        .$get({ query: args })
        .then((r) => formatClientResponse(r)),
  })

export const useFindAuditLogs = (
  args: FindAuditLogsArgs,
  options?: Partial<ReturnType<typeof findAuditLogsQueryOptions>>
) =>
  useQuery({
    ...findAuditLogsQueryOptions(args),
    ...options,
  })
